(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["compliance-faq-accordion"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function closeItem(item, toggle, panel) {
      item.classList.remove('comp-faq__item--open');
      if (toggle) toggle.setAttribute('aria-expanded', 'false');
      if (panel) panel.hidden = true;
    }

    function openItem(item, toggle, panel) {
      if (!toggle || !panel) return;
      item.classList.add('comp-faq__item--open');
      toggle.setAttribute('aria-expanded', 'true');
      panel.hidden = false;
    }

    function bindCompFaq(root) {
      if (!root || root.getAttribute('data-comp-faq-bound') === '1') return;
      root.setAttribute('data-comp-faq-bound', '1');

      root.addEventListener('click', function (ev) {
        var btn = ev.target.closest('[data-comp-faq-toggle]');
        if (!btn || !root.contains(btn)) return;

        var item = btn.closest('[data-comp-faq-item]');
        if (!item) return;

        var panel = item.querySelector('[data-comp-faq-panel]');
        if (!panel) return;

        var isOpen = item.classList.contains('comp-faq__item--open');
        root.querySelectorAll('[data-comp-faq-item]').forEach(function (other) {
          var t = other.querySelector('[data-comp-faq-toggle]');
          var p = other.querySelector('[data-comp-faq-panel]');
          closeItem(other, t, p);
        });

        if (!isOpen) {
          openItem(item, btn, panel);
        }
      });
    }

    function initRoots(from) {
      var scope = from || document;
      scope.querySelectorAll('[data-comp-faq]').forEach(bindCompFaq);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        initRoots();
      });
    } else {
      initRoots();
    }

    document.addEventListener('shopify:section:load', function (ev) {
      var section = ev.target;
      if (section && section.querySelectorAll) {
        section.querySelectorAll('[data-comp-faq]').forEach(function (root) {
          root.removeAttribute('data-comp-faq-bound');
          bindCompFaq(root);
        });
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-hero-dark"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function onReady(fn) {
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', fn);
      } else {
        fn();
      }
    }

    onReady(function () {
      var section = document.getElementById('CustomHeroDark-{{ section.id }}');
      if (!section) return;

      /* HEADING SHIMMER */
      var heading = section.querySelector('[data-shimmer-heading]');
      if (heading && !heading.dataset.shimmerBound) {
        heading.dataset.shimmerBound = 'true';

        // Create shimmer overlay element
        var shimmerLayer = document.createElement('span');
        shimmerLayer.className = 'custom-hero-dark__heading-shimmer-layer';
        heading.appendChild(shimmerLayer);
        heading.classList.add('custom-hero-dark__heading--shimmering');

        var shimmerDuration = 1600;

        window.setTimeout(function () {
          heading.classList.remove('custom-hero-dark__heading--shimmering');
          heading.classList.add('custom-hero-dark__heading--revealed');
          heading.classList.add('custom-hero-dark__heading--no-shimmer');
        }, shimmerDuration);
      }

      /* TABS */
      var tabButtons = section.querySelectorAll('[data-tab-trigger]');
      var panels = section.querySelectorAll('[data-tab-panel]');
      if (!tabButtons.length || !panels.length) return;

      function activateTab(id) {
        tabButtons.forEach(function (btn) {
          var active = btn.getAttribute('data-tab-trigger') === id;
          btn.classList.toggle('custom-hero-dark__tab--active', active);
          btn.setAttribute('aria-selected', active ? 'true' : 'false');
        });

        panels.forEach(function (panel) {
          var active = panel.getAttribute('data-tab-panel') === id;
          panel.classList.toggle('custom-hero-dark__tab-panel--active', active);
        });
      }

      tabButtons.forEach(function (btn) {
        btn.addEventListener('click', function () {
          var id = btn.getAttribute('data-tab-trigger');
          activateTab(id);
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
